import axios from "axios";
import toast from "react-hot-toast";

const PUBLIC_ACCESS_TOKEN_KEY = "public_access_token";

const _BaseAPIService = {
  retrieveToken: () => {
    try {
      const userString = localStorage.getItem("user");
      const user = JSON.parse(userString);
      return user?.token || null;
    } catch (error) {
      console.error("Error retrieving token:", error);
      return null;
    }
  },

  storeToken: (token) => {
    try {
      const userString = localStorage.getItem("user");
      const user = JSON.parse(userString) || {};
      user.token = token;
      localStorage.setItem("user", JSON.stringify(user));
    } catch (error) {
      console.error("Error storing token:", error);
    }
  },

  retrievePublicAccessToken: () => {
    try {
      return sessionStorage.getItem(PUBLIC_ACCESS_TOKEN_KEY) || null;
    } catch (error) {
      console.error("Error retrieving public access token:", error);
      return null;
    }
  },

  storePublicAccessToken: (token) => {
    try {
      sessionStorage.setItem(PUBLIC_ACCESS_TOKEN_KEY, token);
    } catch (error) {
      console.error("Error storing public access token:", error);
    }
  },

  clearPublicAccessToken: () => {
    try {
      sessionStorage.removeItem(PUBLIC_ACCESS_TOKEN_KEY);
    } catch (error) {
      console.error("Error clearing public access token:", error);
    }
  },
};

// Axios instance
_BaseAPIService.instance = axios.create({
  baseURL: window.APP_CONFIG.api1.baseapi,
});

// Attach auth token + public access token to every request
_BaseAPIService.instance.interceptors.request.use(
  (config) => {
    const token = _BaseAPIService.retrieveToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const publicToken = _BaseAPIService.retrievePublicAccessToken();
    if (publicToken) {
      config.headers["X-Public-Page-Access-Token"] = publicToken;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 errors
_BaseAPIService.instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isPublicRoute =
        window.location.pathname.includes("kevsintelligence");

      if (isPublicRoute) {
        console.warn("Public access token expired, clearing...");
        _BaseAPIService.clearPublicAccessToken();
        // Dispatch a custom event so the PasswordGate can react
        window.dispatchEvent(new CustomEvent("publicAccessTokenExpired"));
      } else {
        console.warn("Unauthorized, redirecting to login...");
        localStorage.removeItem("user");
        window.location.href = "/";
      }
    }

    return Promise.reject(error);
  }
);

export default _BaseAPIService;
